import { z } from 'zod';

import { ComponentValidator, ComponentPayloadValidator } from '../Component';

import { AbstractPort, Port } from '../fields/AbstractPort';

import { ComponentDefinition } from '../../types/ComponentDefinition';

const port = AbstractPort.extend({
    AC: Port.AC.default({}),
    DC: Port.DC.default({}),
    isolated: Port.isolated.validator.default(false),
}).default({
    powerFlowDirection: 'bidirectional',
});

const ReferenceBase = z.object({
    type: z.literal('reference').default('reference'),
    reference: z.string().optional(),
    electrical: z
        .object({
            ports: z.array(port).min(0).default([]),
        })
        .default({}),
});

export const ReferenceValidator = ComponentValidator.merge(ReferenceBase);
export const ReferencePayloadValidator = ComponentPayloadValidator.merge(ReferenceBase);

export const ReferenceDefinition: ComponentDefinition = {
    type: 'reference',
    name: 'Reference',
    plural: 'References',
    indicator: 'REF',
    allowCustomIcon: true,
    hasDynamicNumberOfPorts: false,
    interoperabilityDataModel: false,
    searchable: false,
    ports: {
        min: 0,
        max: Infinity,
        powerFlowDirections: ['input', 'output', 'bidirectional'],
    },
    liveData: {
        enabled: true,
        showGraphs: true,
    },
    validators: {
        component: ReferenceValidator,
        payload: ReferencePayloadValidator,
    },
};

export type Reference = z.infer<typeof ReferenceValidator>;
export type ReferencePayload = z.infer<typeof ReferencePayloadValidator>;
